module.exports = __webpack_public_path__ + "assets/images/bag-load.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bag-load.png
// module id = 1488
// module chunks = 1